import { useMemo } from 'react';

const usePackageData = (packages: any, startPage?: boolean) => {
  return useMemo(() => {
    if (!packages) return [];

    const packageList = Object.values(packages) as any[];

    return packageList
      .map((pkg) => ({
        ...pkg,
        typeCode: pkg.componentType,
        image: {
          mobile: pkg.mobileImage,
          tablet: pkg.tabletImage,
          desktop: pkg.desktopImage,
        },
      }))
      .sort((a, b) => a.displayRow - b.displayRow);
  }, [packages, startPage]);
};

export default usePackageData;
